const firebaseConfig = {
  apiKey: "AIzaSyBMJIGMzwbFzT3F7nwLVLDimwf6xWkQ0vk",
  authDomain: "luganodes-crypto.firebaseapp.com",
  projectId: "luganodes-crypto",
  storageBucket: "luganodes-crypto.appspot.com",
  messagingSenderId: "859160477459",
  appId: "1:859160477459:web:a6bc78638288a3a3a624e6"
};

export default firebaseConfig;  